export default __webpack_public_path__ + "static/media/SndLowerOStop.08b6f2aa.mp3";